export default __webpack_public_path__ + "static/media/manali3.f028f78a.webp";